/* eslint-disable import/prefer-default-export */
export const AUTH_COPIES_KEYS = {
  LOGIN: 'login',
  REGISTER: 'register',
  MISSING_INFO: 'missingInfo',
  SUCCESS: 'success',
  FAIL: 'fail',
  LANDING: 'landing',
  CHANGE_PASSWORD_SUCCESSFUL: 'changePasswordSuccessful',
  RESET_PASSWORD: 'resetPassword',
  RESET_PASSWORD_BY_ID: 'resetPasswordById',
}

export const AUTHORIZATION_CODE = 'authorization_code'
export const CODE = 'code'
export const STATE = 'state'
export const RESET_SUCCESSFUL = 'resetSuccessful'
export const RECREATE_PASSWORD_BY_ID = 'RECREATE_PASSWORD_BY_ID'
export const CHANGE_PASSWORD_SUCCESSFUL = 'CHANGE_PASSWORD_SUCCESSFUL'
export const COOKIE_NAME_TO_ACTIVE_NEW_LOGIN = '_IL-enabled-new-auth-methods'
